import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const LowScoreIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-lowScore"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <polygon fill="#ffffff" className={styles.white} opacity="0" points="0 34 68 34 68 0 0 0" />
        <path
          d="M34,3 C20.1927153,3 9,14.1927153 9,28 L9,29 L59,29 L59,28 C59,14.1927153 47.8072847,3 34,3 Z M34.3803519,5.00308129 C46.5280167,5.20003154 56.3861054,14.8142281 56.9724104,26.8634634 L56.977,27 L11.022,27 L11.0275896,26.8634634 C11.620002,14.6887152 21.6783662,5 34,5 L34.3803519,5.00308129 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <polygon
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          points="46.068 7.249 46.932 7.751 34.432 29.251 33.568 28.749"
        />
        <polygon
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          points="20.923 7.234 34.423 28.734 33.577 29.266 20.077 7.766"
        />
        <path
          d="M33.6600037,20.2724 C35.1580037,20.0664 35.8080037,21.8514 34.5280037,22.6564 L28.8970037,26.1964 L19.6600037,32.0044 C18.8990037,32.4824 17.8990037,32.2054 17.6200037,31.4374 L16.3420037,27.9254 L15.0710037,24.4344 C14.7880037,23.6564 15.3830037,22.7894 16.2870037,22.6654 L27.0710037,21.1794 L33.6600037,20.2724 Z"
          fill="#0050B3"
          className={styles.interactiveColor}
          transform="matrix(-1 0 0 1 50.211 0)"
        />
        <path
          d="M39,28 C39,30.761 36.761,33 34,33 C31.239,33 29,30.761 29,28 C29,25.239 31.239,23 34,23 C36.761,23 39,25.239 39,28"
          fill="#ffffff"
          className={styles.white}
        />
        <path
          d="M34,22 C30.6867153,22 28,24.6867153 28,28 C28,31.3132847 30.6867153,34 34,34 C37.3132847,34 40,31.3132847 40,28 C40,24.6867153 37.3132847,22 34,22 Z M34,24 C36.2087153,24 38,25.7912847 38,28 C38,30.2087153 36.2087153,32 34,32 C31.7912847,32 30,30.2087153 30,28 C30,25.7912847 31.7912847,24 34,24 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
      </g>
    </Icon>
  )
}
